export default __webpack_public_path__ + "static/media/login-segment-smartphone-icon.af9cdced.svg";